import React from 'react';

function RelayControllerDc() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_241_759)">
        <g filter="url(#filter0_d_241_759)">
          <path
            d="M55.652 12H24.3459C20.8886 12 18.0859 14.8027 18.0859 18.26V61.742C18.0859 65.1993 20.8886 68.002 24.3459 68.002H55.652C59.1093 68.002 61.9119 65.1993 61.9119 61.742V18.26C61.9119 14.8027 59.1093 12 55.652 12Z"
            fill="#F7F4F1"
          />
          <path
            d="M26.7998 68C28.7218 72.66 33.9058 76 39.9998 76C46.0938 76 51.2778 72.66 53.1998 68H26.7998ZM39.9998 72.922C39.0498 72.922 38.2778 72.152 38.2778 71.2C38.2778 70.248 39.0478 69.478 39.9998 69.478C40.9518 69.478 41.7218 70.248 41.7218 71.2C41.7218 72.152 40.9518 72.922 39.9998 72.922Z"
            fill="#E0DDDA"
          />
          <path
            d="M39.9998 4C33.9038 4 28.7218 7.34 26.7998 12H53.1998C51.2778 7.34 46.0938 4 39.9998 4ZM39.9998 10.52C39.0498 10.52 38.2778 9.75 38.2778 8.798C38.2778 7.846 39.0478 7.076 39.9998 7.076C40.9518 7.076 41.7218 7.846 41.7218 8.798C41.7218 9.75 40.9518 10.52 39.9998 10.52Z"
            fill="#E0DDDA"
          />
          <path
            d="M28.1039 40.958H18.0859V35.95H28.1039C29.4879 35.95 30.6079 37.072 30.6079 38.454C30.6079 39.838 29.4859 40.958 28.1039 40.958Z"
            fill="white"
          />
          <path
            d="M28.1039 50.8H18.0859V45.792H28.1039C29.4879 45.792 30.6079 46.914 30.6079 48.296C30.6079 49.68 29.4859 50.8 28.1039 50.8Z"
            fill="white"
          />
          <path
            d="M28.1039 60.642H18.0859V55.634H28.1039C29.4879 55.634 30.6079 56.756 30.6079 58.138C30.6079 59.522 29.4859 60.642 28.1039 60.642Z"
            fill="white"
          />
          <path
            d="M61.9117 40.958H51.8937C50.5097 40.958 49.3896 39.836 49.3896 38.454C49.3896 37.07 50.5117 35.95 51.8937 35.95H61.9117V40.958Z"
            fill="white"
          />
          <path
            d="M61.9117 50.8H51.8937C50.5097 50.8 49.3896 49.678 49.3896 48.296C49.3896 46.912 50.5117 45.792 51.8937 45.792H61.9117V50.8Z"
            fill="white"
          />
          <path
            d="M61.9117 60.642H51.8937C50.5097 60.642 49.3896 59.52 49.3896 58.138C49.3896 56.754 50.5117 55.634 51.8937 55.634H61.9117V60.642Z"
            fill="white"
          />
          <path
            d="M25.9117 19.8259H37.8077V28.5919H25.9117C25.0477 28.5919 24.3457 27.8899 24.3457 27.0259V21.3919C24.3457 20.5279 25.0477 19.8259 25.9117 19.8259Z"
            fill="url(#paint0_linear_241_759)"
          />
          <path
            d="M42.1924 19.8259H54.0884C54.9524 19.8259 55.6544 20.5279 55.6544 21.3919V27.0259C55.6544 27.8899 54.9524 28.5919 54.0884 28.5919H42.1924V19.8259Z"
            fill="url(#paint1_linear_241_759)"
          />
          <path
            d="M55.6521 11.2H53.7221C51.4741 6.39395 46.0381 3.19995 40.0001 3.19995C33.9621 3.19995 28.5261 6.39395 26.2781 11.2H24.3481C20.4541 11.2 17.2881 14.368 17.2881 18.26V61.74C17.2881 65.634 20.4561 68.7999 24.3481 68.7999H26.2781C28.5261 73.6059 33.9641 76.7999 40.0001 76.7999C46.0361 76.7999 51.4741 73.6059 53.7221 68.7999H55.6521C59.5461 68.7999 62.7121 65.632 62.7121 61.74V18.26C62.7121 14.366 59.5441 11.2 55.6521 11.2ZM61.1121 50H51.8941C50.9541 50 50.1901 49.236 50.1901 48.296C50.1901 47.3559 50.9541 46.592 51.8941 46.592H61.1121V50ZM61.1121 40.158H51.8941C50.9541 40.158 50.1901 39.394 50.1901 38.454C50.1901 37.514 50.9541 36.75 51.8941 36.75H61.1121V40.158ZM40.0001 4.79995C45.1281 4.79995 49.7581 7.32795 51.9261 11.2H40.7741C41.7881 10.872 42.5221 9.91995 42.5221 8.79995C42.5221 7.40995 41.3901 6.27795 40.0001 6.27795C38.6101 6.27795 37.4781 7.40995 37.4781 8.79995C37.4781 9.91995 38.2121 10.872 39.2261 11.2H28.0741C30.2401 7.32795 34.8721 4.79995 40.0001 4.79995ZM39.0781 8.79995C39.0781 8.29195 39.4921 7.87795 40.0001 7.87795C40.5081 7.87795 40.9221 8.29195 40.9221 8.79995C40.9221 9.30795 40.5081 9.72195 40.0001 9.72195C39.4921 9.72195 39.0781 9.30795 39.0781 8.79995ZM18.8861 36.748H28.1041C29.0441 36.748 29.8081 37.512 29.8081 38.452C29.8081 39.3919 29.0441 40.156 28.1041 40.156H18.8861V36.748ZM18.8861 46.59H28.1041C29.0441 46.59 29.8081 47.354 29.8081 48.294C29.8081 49.234 29.0441 49.998 28.1041 49.998H18.8861V46.59ZM18.8861 56.432H28.1041C29.0441 56.432 29.8081 57.1959 29.8081 58.136C29.8081 59.076 29.0441 59.84 28.1041 59.84H18.8861V56.432ZM40.9201 71.198C40.9201 71.7059 40.5061 72.12 39.9981 72.12C39.4901 72.12 39.0761 71.7059 39.0761 71.198C39.0761 70.6899 39.4901 70.276 39.9981 70.276C40.5061 70.276 40.9201 70.6899 40.9201 71.198ZM39.9981 75.198C34.8701 75.198 30.2401 72.67 28.0721 68.798H39.2241C38.2121 69.126 37.4761 70.0779 37.4761 71.198C37.4761 72.588 38.6081 73.72 39.9981 73.72C41.3881 73.72 42.5201 72.588 42.5201 71.198C42.5201 70.0779 41.7861 69.126 40.7721 68.798H51.9221C49.7561 72.67 45.1241 75.198 39.9961 75.198H39.9981ZM55.6501 67.1979H24.3481C21.3361 67.1979 18.8881 64.748 18.8881 61.738V61.442H28.1061C29.9281 61.442 31.4101 59.96 31.4101 58.138C31.4101 56.316 29.9281 54.834 28.1061 54.834H18.8881V51.6H28.1061C29.9281 51.6 31.4101 50.118 31.4101 48.296C31.4101 46.4739 29.9281 44.992 28.1061 44.992H18.8881V41.7579H28.1061C29.9281 41.7579 31.4101 40.276 31.4101 38.454C31.4101 36.632 29.9281 35.15 28.1061 35.15H18.8881V18.26C18.8881 15.248 21.3381 12.8 24.3481 12.8H55.6521C58.6641 12.8 61.1121 15.25 61.1121 18.26V35.148H51.8941C50.0721 35.148 48.5901 36.63 48.5901 38.452C48.5901 40.2739 50.0721 41.756 51.8941 41.756H61.1121V44.99H51.8941C50.0721 44.99 48.5901 46.472 48.5901 48.294C48.5901 50.116 50.0721 51.5979 51.8941 51.5979H61.1121V54.832H51.8941C50.0721 54.832 48.5901 56.3139 48.5901 58.136C48.5901 59.958 50.0721 61.44 51.8941 61.44H61.1121V61.736C61.1121 64.748 58.6621 67.196 55.6521 67.196L55.6501 67.1979ZM61.1101 59.84H51.8921C50.9521 59.84 50.1881 59.076 50.1881 58.136C50.1881 57.1959 50.9521 56.432 51.8921 56.432H61.1101V59.84Z"
            fill="#84827E"
          />
          <path
            d="M37.8079 19.0259H25.9119C24.6079 19.0259 23.5459 20.0879 23.5459 21.3919V27.0259C23.5459 28.3299 24.6079 29.3919 25.9119 29.3919H37.8079C38.2499 29.3919 38.6079 29.0339 38.6079 28.5919V19.8259C38.6079 19.3839 38.2499 19.0259 37.8079 19.0259ZM37.0079 27.7919H25.9119C25.4899 27.7919 25.1459 27.4479 25.1459 27.0259V21.3919C25.1459 20.9699 25.4899 20.6259 25.9119 20.6259H37.0079V27.7919Z"
            fill="#84827E"
          />
          <path
            d="M56.4517 27.0259V21.3919C56.4517 20.0879 55.3896 19.0259 54.0856 19.0259H42.1896C41.7476 19.0259 41.3896 19.3839 41.3896 19.8259V28.5919C41.3896 29.0339 41.7476 29.3919 42.1896 29.3919H54.0856C55.3896 29.3919 56.4517 28.3299 56.4517 27.0259ZM42.9917 20.6259H54.0877C54.5097 20.6259 54.8536 20.9699 54.8536 21.3919V27.0259C54.8536 27.4479 54.5097 27.7919 54.0877 27.7919H42.9917V20.6259Z"
            fill="#84827E"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_241_759"
          x="15.8881"
          y="1.79995"
          width="51.4238"
          height="79.6001"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.6" dy="1.6" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_241_759"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_241_759"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_241_759"
          x1="26.2391"
          y1="20.61"
          x2="31.3966"
          y2="29.6952"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_241_759"
          x1="44.0858"
          y1="20.61"
          x2="49.2433"
          y2="29.6952"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
        <clipPath id="clip0_241_759">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default RelayControllerDc;
